import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
const BasicUserInformation = (props) => {
  const { userData } = props.parentState.newFormData;
  const { oibValidated } = userData;
  const { stranac } = props;
  return (
    <div className="form-group">
      <Row>
        <Col>
          <InputComponent
            required={
              stranac
                ? userData.idBroj.length < 1 ||
                  (userData.idBroj.length > 0 && userData.oib.length > 0)
                : true
            }
            disabled={props.disabled || (stranac && userData.idBroj.length > 0)}
            style={
              !stranac
                ? props.required &&
                  props.parentState.error &&
                  userData.oib.length < 1 &&
                  "red"
                : props.required &&
                  props.parentState.error &&
                  userData.idBroj.length < 1 &&
                  userData.oib.length < 1 &&
                  "red"
            }
            minLength={11}
            maxLength={11}
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.oib}
            id="oib-user-data"
            name="oib"
            controlLabel={"OIB"}
          />
          {!oibValidated &&
            userData.oib.length <= 11 &&
            userData.oib.length > 0 && (
              <p style={{ color: "red" }}>Oib nije ispravan!</p>
            )}
        </Col>
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              userData.prezime.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.prezime}
            name="prezime"
            id="prezime-user-data"
            controlLabel={"Prezime"}
          />
        </Col>
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              userData.ime.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.ime}
            name="ime"
            id="ime-user-data"
            controlLabel={"Ime"}
          />
        </Col>
      </Row>
      {userData.vrOsobe === "1" && (
        <Row>
          <Col>
            <InputComponent
              value={userData.telefon}
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              id="telefon-user-data"
              name="telefon"
              controlLabel={"Telefon"}
              type="tel"
            />
          </Col>
          <Col>
            <InputComponent
              value={userData.email}
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              id="email-user-data"
              name="email"
              controlLabel={"E-mail"}
              style={
                props.parentState.error &&
                !userData.emailValidated &&
                "red"
              }
            />
          </Col>
          <Col></Col>
        </Row>
      )}
      {stranac && (
        <Row>
          <Col>
            <InputComponent
              required={
                userData.oib.length < 1 ||
                (userData.oib.length > 0 && userData.idBroj.length > 0)
              }
              disabled={props.disabled || userData.oib.length > 0}
              style={
                props.required &&
                props.parentState.error &&
                userData.idBroj.length < 1 &&
                userData.oib.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              value={userData.idBroj}
              id="id-br-user-data"
              name="idBroj"
              controlLabel={"Identifikator"}
            />
          </Col>
          <Col></Col>
          <Col></Col>
        </Row>
      )}
    </div>
  );
};

export default BasicUserInformation;
